import { useStressAssessmentSummary } from './hooks';
import { convertToPresentationProps } from './logics';
import { StressAssessmentSummaryPresentation } from './presentations';

type Props = {
  stressAssessmentId: number;
};

export const StressAssessmentSummary: React.FC<Props> = ({ stressAssessmentId }) => {
  const {
    state: { data },
    unsetBranchUserCount,
    onClickReportGuide,
    isDialogOpen,
    isDontShowAgainChecked,
    onConfirmDialog,
    onCancelDialog,
    onCloseDialog,
    onChangeDontShowAgain,
    isLinkageDialogOpen,
    onConfirmLinkageDialog,
    onCancelLinkageDialog,
  } = useStressAssessmentSummary({ stressAssessmentId: stressAssessmentId.toString() });

  const {
    title,
    totalUserCount,
    completedUserCount,
    completedUserRate,
    highStressUserCount,
    highStressUserRate,
    pendingUserCount,
    pendingUserRate,
    dataPoints,
    showReportGuide,
    showUnsetBranchUserAlert,
  } = convertToPresentationProps({ data });

  return (
    <StressAssessmentSummaryPresentation
      title={title}
      totalUserCount={totalUserCount}
      completedUserCount={completedUserCount}
      completedUserRate={completedUserRate}
      highStressUserCount={highStressUserCount}
      highStressUserRate={highStressUserRate}
      pendingUserCount={pendingUserCount}
      pendingUserRate={pendingUserRate}
      dataPoints={dataPoints}
      showReportGuide={showReportGuide}
      showUnsetBranchUserAlert={showUnsetBranchUserAlert}
      unsetBranchUserCount={unsetBranchUserCount}
      onClickReportGuide={onClickReportGuide}
      isDialogOpen={isDialogOpen}
      isDontShowAgainChecked={isDontShowAgainChecked}
      onConfirmDialog={onConfirmDialog}
      onCancelDialog={onCancelDialog}
      onCloseDialog={onCloseDialog}
      onChangeDontShowAgain={onChangeDontShowAgain}
      isLinkageDialogOpen={isLinkageDialogOpen}
      onConfirmLinkageDialog={onConfirmLinkageDialog}
      onCancelLinkageDialog={onCancelLinkageDialog}
    />
  );
};
